export const toInches = meters => meters * 39.3701;

export const toMeters = inches => inches / 39.3701;
